import React, { PureComponent } from 'react'
import { Columns } from 'react-bulma-components'
import { Text, MessageBar } from '@fluentui/react'
import styles from 'styles/pages/_publicLayout.module.scss'
import Card from 'components/containers/card'
import BackgroundImg from 'assets/img/bg.png'
import LogoImg from 'assets/img/logo.png'

/**
 * @typedef {object} PublicLayoutProps
 * @property {boolean} isDisplay Is layout is displayed
 * @augments {PureComponent<import('app').AppProps & PublicLayoutProps & {children: React.ReactNode}>}
 */
export default class PublicLayout extends PureComponent {
    render() {
        const {
            isDisplay, children, messageBar, setMessageBar,
        } = this.props

        if (!isDisplay)
            return children

        return (
            <section
                className={styles.layout}
                // eslint-disable-next-line global-require
                style={{ background: `url(${BackgroundImg}), white` }}
            >
                <Columns>
                    <Columns.Column className="is-hidden-touch" />

                    <Columns.Column>
                        <div className="flex-col">
                            <Card
                                className="has-text-centered"
                            >
                                <img
                                    src={LogoImg}
                                    alt={import.meta.env.VITE_SHORT_NAME}
                                />
                                <br />
                                <Text
                                    variant="xxLarge"
                                    block
                                >
                                    {import.meta.env.VITE_NAME}
                                </Text>
                                <br />

                                {
                                    messageBar.isDisplayed
                                    && (
                                        <>
                                            <MessageBar
                                                messageBarType={messageBar.type}
                                                isMultiline={false}
                                                truncated
                                                onDismiss={() => setMessageBar({ isDisplayed: false })}
                                            >
                                                {messageBar.message}
                                            </MessageBar>
                                            <br />
                                        </>
                                    )
                                }
                                {children}
                            </Card>
                        </div>
                    </Columns.Column>
                    <Columns.Column className="is-hidden-touch" />
                </Columns>
            </section>
        )
    }
}
